
// SVG Icon: warning
export default { id: "terriajs-warning" };
export const id = "terriajs-warning";
export const name = "warning";
